// 외주 의뢰서 확장 — 공용 스타일·작은 부품 (2026-10-13). 기존 OutsourceRequestPage 의 토큰(#6366f1·흰 카드·파스텔 칩)과 같은 문법.
// 화면 정본 = 미리보기 v11 https://claude.ai/artifact/DVmQLM9Hx9sYSFyH2CuUkD (10-13 대표 결정이 우선 — 접수·출고·받음 없음)
import React from 'react';
import { MF_KIND_LABEL, MF_KIND_COLOR, MF_STATUS, mfMsOf } from '../../services/outsourceMfApi';

export const S = {
    card: { background: 'white', borderRadius: 12, border: '1px solid #e2e8f0', boxShadow: '0 1px 3px rgba(0,0,0,0.06)', padding: 16, marginBottom: 12 },
    cardTitle: { fontSize: 15, fontWeight: 700, color: '#0f172a', margin: '0 0 12px', display: 'flex', alignItems: 'center', gap: 8 },
    label: { display: 'block', fontSize: 12.5, fontWeight: 600, color: '#475569', marginBottom: 6 },
    input: { width: '100%', border: '1px solid #e2e8f0', borderRadius: 8, padding: '9px 12px', fontSize: 13.5, color: '#334155', background: '#fff', outline: 'none', boxSizing: 'border-box' },
    hint: { fontSize: 12, color: '#94a3b8', marginTop: 6, lineHeight: 1.55 },
    warn: { fontSize: 12, color: '#c2410c', marginTop: 6 },
    priBtn: { display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6, padding: '9px 16px', backgroundColor: '#6366f1', border: 'none', borderRadius: 8, fontSize: 13.5, fontWeight: 700, color: '#fff', cursor: 'pointer' },
    ghostBtn: { display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6, padding: '9px 16px', backgroundColor: '#fff', border: '1px solid #e2e8f0', borderRadius: 8, fontSize: 13.5, fontWeight: 600, color: '#475569', cursor: 'pointer' },
    dangerBtn: { display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6, padding: '9px 16px', backgroundColor: '#fff', border: '1px solid #fca5a5', borderRadius: 8, fontSize: 13.5, fontWeight: 700, color: '#dc2626', cursor: 'pointer' },
    chipBtn: (on) => ({ padding: '7px 14px', borderRadius: 8, border: `1px solid ${on ? '#6366f1' : '#e2e8f0'}`, background: on ? '#6366f1' : '#fff', color: on ? '#fff' : '#475569', fontSize: 13, fontWeight: 600, cursor: 'pointer' }),
    th: { textAlign: 'left', fontSize: 12, color: '#64748b', fontWeight: 600, padding: '10px 12px', borderBottom: '1px solid #e2e8f0', background: '#f8fafc', whiteSpace: 'nowrap' },
    td: { fontSize: 13, color: '#334155', padding: '11px 12px', borderBottom: '1px solid #f1f5f9', verticalAlign: 'middle' },
    info: { background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 10, padding: '10px 14px', fontSize: 12.5, color: '#475569', lineHeight: 1.6, marginBottom: 12 },
    tag: { display: 'inline-block', padding: '2px 8px', borderRadius: 6, fontSize: 11.5, fontWeight: 600, background: '#f8fafc', color: '#475569', border: '1px solid #e2e8f0', marginRight: 4, marginBottom: 4 },
};

export function KindChip({ kind, small }) {
    const c = MF_KIND_COLOR[kind] || MF_KIND_COLOR.etc;
    return <span style={{ display: 'inline-block', padding: small ? '1px 7px' : '2px 9px', borderRadius: 6, fontSize: small ? 11 : 12, fontWeight: 700, color: c.fg, background: c.bg, whiteSpace: 'nowrap' }}>{MF_KIND_LABEL[kind] || kind}</span>;
}

export function StatusChip({ status, received }) {
    const st = MF_STATUS[status] || { text: status, fg: '#475569', bg: '#f1f5f9' };
    const text = received && status === 'pending' ? (st.recvText || st.text) : st.text;
    const fg = received && status === 'pending' ? '#c2410c' : st.fg;
    const bg = received && status === 'pending' ? '#ffedd5' : st.bg;
    return <span style={{ display: 'inline-block', padding: '3px 10px', borderRadius: 6, fontSize: 12, fontWeight: 700, color: fg, background: bg, whiteSpace: 'nowrap' }}>{text}</span>;
}

/** 중개 고지 — 종류별 문구(법무 보충). 모든 의뢰 화면 */
// plain = 박스 없이 화면 아래 작은 회색 한 줄(대표 10-15 "안내 공지글이 너무 많아" — 글자는 그대로, 보이는 모양만)
export function MfBrokerNotice({ kind, style, plain = false }) {
    let text = '덴클은 주문을 연결할 뿐 거래 당사자가 아닙니다. 제작은 수주 기공소가, 최종 기공물 검수와 치과 납품은 주문한 기공소가 책임집니다. 대금은 업체와 직접 정산합니다.';
    if (kind === 'cnc') text = '덴클은 거래 당사자가 아니며, 제품의 허가·품질 책임은 제조 업체에, 최종 기공물 책임은 주문 기공소에 있습니다. 대금은 업체와 직접 정산합니다.';
    if (kind === 'metal') text = '덴클은 주문을 연결할 뿐 거래 당사자가 아닙니다. 구조물 제작은 수주 업체가, 최종 기공물 완성과 치과 납품은 주문한 기공소가 책임집니다. 대금은 업체와 직접 정산합니다.';
    if (plain) return <div style={{ fontSize: 11.5, color: '#94a3b8', lineHeight: 1.6, margin: '8px 2px 0', ...style }}>{'ⓘ '}{text}</div>;
    return <div style={{ ...S.info, ...style }}>{'ⓘ '}{text}</div>;
}

export const fmtMd = (v) => { const ms = mfMsOf(v); if (ms == null) return ''; const d = new Date(ms); return `${String(d.getMonth() + 1).padStart(2, '0')}.${String(d.getDate()).padStart(2, '0')}`; };
export const fmtMdHm = (v) => { const ms = mfMsOf(v); if (ms == null) return ''; const d = new Date(ms); return `${fmtMd(ms)} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`; };
export const fmtDue = (s) => (typeof s === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(s) ? `${s.slice(5, 7)}.${s.slice(8, 10)}` : '');

/** 3단계 진행 막대(보냄·확인·제작 중) */
export function MfStepper({ order }) {
    const steps = [
        { key: 'pending', label: '보냄', at: order.createdAt, sub: '' },
        { key: 'opened', label: '확인', at: order.openedAt, sub: '업체가 열어 봄' },
        { key: 'in_production', label: '제작 중', at: order.firstDownloadedAt, sub: 'STL 내려받음' },
        { key: 'shipped', label: '출고', at: order.shippedAt, sub: order.trackingNo ? `송장 ${order.trackingNo}` : '업체가 출고' },   // 10-23
    ];
    const cur = (MF_STATUS[order.status] || {}).step || 0;
    return (
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 0, margin: '14px 0 4px' }}>
            {steps.map((s, i) => {
                const done = cur > i + 1 || (cur === steps.length && i === steps.length - 1);
                const active = cur === i + 1;
                const on = done || active;
                return (
                    <div key={s.key} style={{ flex: 1, textAlign: 'center', position: 'relative' }}>
                        {i > 0 && <div style={{ position: 'absolute', top: 11, right: '50%', width: '100%', height: 2, background: cur > i ? '#6366f1' : '#e2e8f0' }} />}
                        <div style={{ position: 'relative', width: 22, height: 22, borderRadius: 11, margin: '0 auto', background: on ? '#6366f1' : '#fff', border: `2px solid ${on ? '#6366f1' : '#cbd5e1'}`, color: '#fff', fontSize: 12, lineHeight: '18px' }}>{done ? '✓' : ''}</div>
                        <div style={{ fontSize: 13, fontWeight: active ? 700 : 600, color: on ? '#0f172a' : '#94a3b8', marginTop: 6 }}>{s.label}</div>
                        <div style={{ fontSize: 11.5, color: '#94a3b8' }}>{s.at ? `${fmtMdHm(s.at)}${s.sub ? ' · ' + s.sub : ''}` : ''}</div>
                    </div>
                );
            })}
        </div>
    );
}

/** 상태 기록(자동) — 열어 봄·내려받음 포함 */
export function MfStatusLog({ order, viewer }) {
    const rows = [];
    if (order.status === 'rejected') rows.push({ chip: 'rejected', at: order.rejectedAt, text: `업체가 거절 — 사유: ${order.rejectReason || ''}` });
    if (order.status === 'cancelled') rows.push({ chip: 'cancelled', at: order.cancelledAt, text: order.cancelledBy === 'system' ? '업체가 30일 동안 확인하지 않아 자동 취소' : `보낸 기공소가 취소${order.cancelReason ? ' — ' + order.cancelReason : ''}` });
    if (order.shippedAt) rows.push({ chip: 'shipped', at: order.shippedAt, text: `업체가 출고${order.trackingNo ? ` — 송장 ${order.trackingNo}` : ''}` });   // 10-23
    if (order.firstDownloadedAt) rows.push({ chip: 'in_production', at: order.firstDownloadedAt, text: `업체 담당자가 STL ${order.fileCount || ''}개 중 내려받음 (자동)` });
    if (order.openedAt) rows.push({ chip: 'opened', at: order.openedAt, text: viewer === 'vendor' ? '내가 의뢰를 열어 봄 (자동)' : '업체 담당자가 의뢰를 열어 봄 (자동)' });
    rows.push({ chip: 'pending', at: order.createdAt, text: order.fromName || '보낸 기공소' });
    return (
        <div>
            {rows.map((r, i) => (
                <div key={i} style={{ display: 'flex', gap: 10, padding: '6px 0' }}>
                    <span style={{ width: 8, height: 8, borderRadius: 4, background: i === 0 ? '#6366f1' : '#cbd5e1', marginTop: 7, flexShrink: 0 }} />
                    <div>
                        <StatusChip status={r.chip} received={viewer === 'vendor'} /> <span style={{ fontSize: 12, color: '#94a3b8' }}>{fmtMdHm(r.at)}</span>
                        <div style={{ fontSize: 13, color: '#334155', marginTop: 2 }}>{r.text}</div>
                    </div>
                </div>
            ))}
        </div>
    );
}

/** FDI 치아 고르기(낱개/연결) */
const UPPER = [18, 17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27, 28];
const LOWER = [48, 47, 46, 45, 44, 43, 42, 41, 31, 32, 33, 34, 35, 36, 37, 38];
export function ToothPicker({ teeth, bridge, onChange }) {
    const toggle = (t) => onChange(teeth.includes(t) ? teeth.filter((x) => x !== t) : [...teeth, t], bridge);
    const btn = (t) => {
        const on = teeth.includes(t);
        return <button key={t} type="button" onClick={() => toggle(t)} style={{ width: 38, height: 38, borderRadius: 8, border: `2px solid ${on ? '#6366f1' : '#e2e8f0'}`, background: on ? '#eef2ff' : '#f8fafc', color: on ? '#3730a3' : '#64748b', fontWeight: on ? 700 : 500, fontSize: 13, cursor: 'pointer' }}>{t}</button>;
    };
    const row = (list) => (
        <div style={{ display: 'flex', gap: 4, justifyContent: 'center', flexWrap: 'wrap' }}>
            {list.slice(0, 8).map(btn)}<span style={{ width: 12 }} />{list.slice(8).map(btn)}
        </div>
    );
    return (
        <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <span style={S.label}>{'치아'}</span>
                <button type="button" style={S.chipBtn(!bridge)} onClick={() => onChange(teeth, false)}>{'낱개'}</button>
                <button type="button" style={S.chipBtn(bridge)} onClick={() => onChange(teeth, true)}>{'연결'}</button>
                <span style={{ fontSize: 12, color: '#94a3b8' }}>{'FDI · 치아를 눌러 고르기'}</span>
                <span style={{ flex: 1 }} />
                <b style={{ fontSize: 13 }}>{teeth.slice().sort((a, b) => a - b).map((t) => `#${t}`).join(' ')}</b>
            </div>
            <div style={{ fontSize: 11, color: '#94a3b8', textAlign: 'center' }}>{'상악'}</div>
            {row(UPPER)}
            <div style={{ height: 6 }} />
            {row(LOWER)}
            <div style={{ fontSize: 11, color: '#94a3b8', textAlign: 'center' }}>{'하악'}</div>
        </div>
    );
}

export function Modal({ title, onClose, children, footer, width = 560 }) {
    return (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 16 }} onClick={onClose}>
            <div style={{ background: '#fff', borderRadius: 14, width: '100%', maxWidth: width, maxHeight: '90vh', overflow: 'auto' }} onClick={(e) => e.stopPropagation()}>
                <div style={{ padding: '16px 20px', borderBottom: '1px solid #f1f5f9', fontSize: 16, fontWeight: 700 }}>{title}</div>
                <div style={{ padding: 20 }}>{children}</div>
                {footer && <div style={{ padding: '12px 20px', borderTop: '1px solid #f1f5f9', display: 'flex', justifyContent: 'flex-end', gap: 8 }}>{footer}</div>}
            </div>
        </div>
    );
}
